import { useNavigate } from "react-router";
import { getFullDate } from "../../../../misc/misc";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import "./SingleDesignTablet.css";
import { countryMap } from "../../../../utils/constants";
import ReactCountryFlag from "react-country-flag";
import ShareButtonsMobile from "../../../../components/Buttons/ShareButtonsMobile/ShareButtonsMobile";
import VoteBtn from "../../../../components/Buttons/VoteBtn/VoteBtn";

const SingleDesignTablet = ({
  changeDesign,
  design,
  likes,
  handleDownload,
  vote,
  onClickDeleteDesign,
  shareUrl,
  userName,
  leftArrow,
  rightArrow,
  userIcon,
  calendarIcon,
  downloadIcon,
  checkIcon,
  user,
  currentIndex,
  designsCount,
  locationData,
  voteBtnState,
  onClickVote,
  onChangeEmail,
  email,
  deleteBtnText
}) => {
  const navigate = useNavigate();
  const noTitle = `${locationData?.location} Design - ${currentIndex}`

  return (
    <>
      <div className="pin_page_heading_tab">
        <div className="titles_wrapper_main">
          <div className="title_small">CoTown</div>
          <div className="title_large">
            <span className="title_word_background_line_wrapper">
              <span className="title_word_background_line"></span>
              DESIGN
            </span>
            {" " + "SHOWCASE"}
          </div>
        </div>
      </div>
      <div className="design_page_content_tab">
        <div className="design_description_tab">
          <div className="design_location_tab">
            <p className="country_tab aligned_text">
            <ReactCountryFlag
                  countryCode={countryMap.get(locationData?.country)}
                  svg
                  style={{ width: '32px', height: '20px' }}
                  title={locationData?.country}
                  />
              {locationData?.country}
              </p>
            <p className="location_tab">{locationData?.location + ', ' +  locationData?.city }</p>
          </div>
          <div className="subheading_tab">
            <div className="design_creation_tab">
              <div className="user_name aligned_text">
                <img src={userIcon} />
                {userName}
              </div>
              <div className="creation_date aligned_text">
                <img src={calendarIcon} />
                {getFullDate(design.createdAt)}
              </div>
            </div>
            <div className="design_nav_buttons_tab">
              {/* <div
                className="back_btn_tab"
                onClick={() => navigate(`/${cityName}/${design.pin_id}`)}
              >
                &#60; Back to Gallery
              </div> */}
              <div className="design_change_tab">
                <button
                  onClick={() => changeDesign("prev")}
                  className="design_back"
                >
                  <img src={rightArrow} />
                </button>
                <span className="mx-5"> {currentIndex} of {designsCount} </span>
                <button
                  onClick={() => changeDesign("next")}
                  className="design_fore"
                >
                  <img src={leftArrow} />
                </button>
              </div>
            </div>
          </div>
          <div className="main_content_tab">
            <img
              className="single_design_image_tab"
              src={design.image}
              alt="Thumbnail"
            />
             <div className="image_info_btns_tab">
                <div className="single_des_info_btns_left_col_tab">
                  <VoteBtn 
                    vote={vote} 
                    onClickVote={onClickVote} 
                    onChangeEmail={onChangeEmail}
                    email={email}
                    voteBtnState={voteBtnState}
                  ></VoteBtn>
                  <div className="image_votes aligned_text">
                    <img src={checkIcon} alt="Votes Icon" /> {likes || 0} Votes
                  </div>
                </div>
                <div className="single_des_info_btns_right_col_tab">
                  <ShareButtonsMobile facebookUrl={shareUrl}></ShareButtonsMobile> 
                  <button className="download_btn aligned_text" onClick={handleDownload}>
                    Download
                    <img style={{marginLeft: '10px'}} src={downloadIcon} alt="download" />
                  </button>
                </div>      
              </div>
              <div className="single_des_hor_line_tab"></div>
              <div>
                  <p className="single_des_title_label" style={{margin: '20px 0 0 0'}}>Title:</p>
                  <p className="single_des_title" style={{marginTop: 0}}>{design?.title || noTitle}</p>
                  {design?.comment && 
                   <>
                   <p className="single_des_comment_label" style={{margin: 0}}>Description:</p>
                   <p className="single_des_comment" style={{marginTop: 0}}>{design?.comment}</p>
                  </>
                  }
              </div>
              <div className="single_des_hor_line_tab"></div>

              <div style={{display: 'inline-block'}}>
                <button 
                  className="btn_rounded_border_animation" 
                  onClick={() => navigate(`/pin/${design.pin_id}/create-design`)}
                >
                  <span className="btn_rounded_border_animation_text">Make your own design</span>
                </button>
              </div>
            {/* <div className="image_info_btns_tab">
              <div className="image_votes_tab aligned_text">
                <img src={checkIcon} alt="Votes Icon" /> {likes || 0} Votes
              </div>
              <div className="download_share_tab">
                <button
                  className="download_btn_tab aligned_text"
                  onClick={handleDownload}
                >
                  <img src={downloadIcon} alt="Download Icon" />
                  Download
                </button>

                <ShareButtonsMobile facebookUrl={shareUrl}></ShareButtonsMobile>
              </div>
            </div>
              <div>
                  <p className="single_des_title_label" style={{margin: 0}}>Title:</p>
                  <p className="single_des_title" style={{marginTop: 0}}>{design?.title || noTitle}</p>
                  {design?.comment && 
                  <>
                    <p  className="single_des_comment_label"style={{margin: 0}}>Description:</p>
                    <p className="single_des_comment" style={{marginTop: 0}}>{design?.comment}</p>
                  </>
                  }
              </div>
            <div className="horizontal_line_tab"></div>
            <div style={{ margin: "20px 0 20px 0" }}>
              <VoteBtn 
                vote={vote} 
                disableVoteBtn={disableVoteBtn} 
                onClickVote={onClickVote} 
                onChangeEmail={onChangeEmail}
                email={email}
                voteBtnState={voteBtnState}
              ></VoteBtn>
            </div>
            <div>
              <button
                onClick={() => navigate(`/pin/${design.pin_id}/create-design`)}
                className="btn_rounded_border_animation make_design_btn"
              >
                <span className="btn_rounded_border_animation_text">Make your own design</span>
              </button>
            </div> */}
            {user?.length > 0 && (
              <Button
                variant="contained"
                color="error"
                sx={{ marginTop: "20px" }}
                onClick={onClickDeleteDesign}
              >
                {deleteBtnText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleDesignTablet;
